<template>
  <el-button size="mini" type="danger" plain @click="onSubmit">
    Delete
  </el-button>
</template>

<script>
export default {
  props: {
    ingredientId: String,
  },
  methods: {
    async onSubmit() {
      try {
        await this.$confirm('The ingredient will be permanently deleted.', 'Confirm Delete', {
          confirmButtonText: 'Delete',
          cancelButtonText: 'Cancel',
          type: 'warning'
        })
      } catch(err) {
        return false
      }

      try {
        var { data } = await this.$http.delete(`/ingredients/${ this.ingredientId }`)
      } catch(err) {
        this.$message.error(err.response.data.message)
        return false
      } finally {
        this.loading = false
      }

      this.$emit('delete')
      this.$message.success(data.message)
    },
  },
}
</script>
